import type { JSX } from "react";
import { Outlet, useMatches } from "react-router";
import { Stack, Box } from "@mui/material";
import NavBar from "@/ui/nav-bar";
import RequireAuth from "@/auth/require-auth";

function wantsBackButton(handle: unknown): boolean {
  return (
    typeof handle === "object" &&
    handle !== null &&
    "backButton" in handle &&
    handle.backButton === true
  );
}

export default function AuthenticatedLayout(): JSX.Element {
  const matches = useMatches();
  const backButton = matches.some((m) => wantsBackButton(m.handle));
  return (
    <Stack height="100%">
      <NavBar backButton={backButton} />
      <Box flex={1} minHeight={0}>
        <RequireAuth>
          <Outlet />
        </RequireAuth>
      </Box>
    </Stack>
  );
}
